const trackShipmentSection = "/track-shipment";

export const trackShipmentPath = trackShipmentSection;
